import React, { ReactElement } from "react";
import TrackEmbed, { TrackEmbedProps } from "../components/TrackEmbed";

const Listen = (): ReactElement => {
  const trackProps: TrackEmbedProps[] = [
    { title: "Hum", id: "1809285228" },
    { title: "Lucky", id: "1805121957" },
    // { title: "stainless", id: "1606359546" },
    { title: "bios", id: "1606359522" },
    { title: "mirror", id: "1510742692" },
    // { title: "daybreak", id: "1510742524" },
    // { title: "genesis", id: "1510742461" },
    // { title: "from-joeyy-bckspc-remix", id: "1510741780" },
    // { title: "brokeboi", id: "663989324" },
    // { title: "ramble", id: "726082687" },
    // { title: "razor", id: "452963160" },
    // { title: "shatter", id: "380106734" },
    // { title: "Ｇｈｏｓｔ.", id: "332883150" },
    // { title: "ＭｉｓｓｉＮ", id: "332883143" },
  ];

  return (
    <div className="page-container">
      <p className="button" style={{ marginBottom: "5px" }}>
        <a
          href="https://soundcloud.com/bckspcmedia"
          target="_blank"
          rel="noreferrer"
        >
          SoundCloud Page
        </a>
      </p>
      <div className="media-list-flex">
        {trackProps.map((props: TrackEmbedProps) => (
          <TrackEmbed key={props.title} title={props.title} id={props.id} />
        ))}
      </div>
    </div>
  );
};

export default Listen;
